import { Field as Fieldmik, Form as Formiker, withFormik } from "formik";
import React, { useEffect, useState } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  Button, Dropdown, Form as FormUi, Modal, TextArea
} from "semantic-ui-react";
import * as yup from "yup";
import {
  errorAlertDispatcher, successAlertDispatcher
} from "../../redux/actions/alertAction";
import { AllRegex } from "../../utils/validation";
import { FIELD_IS_REQUIRED, INVALID_PAN_NUMBER } from "../../utils/validationConstant";
import CreateAxios from "../axiosComponent/create";
import ReadAxios from "../axiosComponent/read";
import { MyNormalInput } from "../dynamicComponent/myInputs";

const ModalCreateConsignee = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [customertype, setcustomertype] = useState([]);
  const [industryName, setindustryName] = useState([]);
  const [isloading, setLoading] = useState(false);

  useEffect(() => {
    getCustomerType();
    getIndustry();

  }, []);

  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
    // if (values.vendor) handleSubmit();
  };

  const handleSubmited = () => {
    if (values.billingPartyName &&
      values.billingPartyAddress && values.billingPartyContactPersonNumber && values.billingPartyAddress && values.billingPartyPincodeNo) {
      handleSubmit();
      setmodalOpen(false);
    } else {
      handleSubmit();
    }
  };

  const getCustomerType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/billingPartyPaymentType`,
    })
      .then((res) => {
        // this.props.create(temShipment);
        setLoading(false);
        let ownership = res.data.resultSet;
        setcustomertype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.billingPartyPaymentTypeId,
              text: item.billingPartyPaymentTypeName,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getIndustry = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/industry_segment`,
    })
      .then((res) => {
        // this.props.create(temShipment);
        setLoading(false);
        let industry = res.data.resultSet;
        setindustryName(
          industry.map((item, index) => {
            return {
              key: index,
              value: item.industrySegmentId,
              text: item.industrySegmentName,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        // size="tiny"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            className="ui billing-party_button"
          >
            <i aria-hidden="true" className="add icon"></i>
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {"Add Billing Party"}
        </Modal.Header>
        <Modal.Content scrolling style={{ height: "18em" }}>
          <Modal.Description style={{ height: "10em" }}>
            <div className="ui form">
              <Formiker>
                <div className="container-fluid animated slideInDown pad w3-white">
                  <div className="m-3 pl-3">
                    <div className="ui form">
                      <FormUi.Group inline>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("billingPartyCode.title") || "Consignee Code"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                          error={
                            false
                          }
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="billingPartyCode"
                            placeholder={t("billingPartyCode.placeholder") || "Code"}
                          //   disabled={editData.billingPartyCode ? true : false}
                          />
                          {/* {customerNumber != 1379 && touched.billingPartyCode && errors.billingPartyCode ? (
                            <div>
                              {t(`billingPartyCode.error_msg.${errors.billingPartyCode}`) ||
                                errors.billingPartyCode}
                            </div>
                          ) : null} */}
                        </FormUi.Field>
                        <FormUi.Field width={2}></FormUi.Field>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("billingPartyName.title") || "Billing Part Name"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                          error={
                            touched.billingPartyName && errors.billingPartyName ? true : false
                          }
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="billingPartyName"
                            placeholder={t("billingPartyName.placeholder") || "Name"}
                          />
                          {touched.billingPartyName && errors.billingPartyName ? (
                            <div>
                              {t(`billingPartyName.error_msg.${errors.billingPartyName}`) ||
                                errors.billingPartyName}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("email.title") || "Email Id"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                          error={touched.billingPartyEmail && errors.billingPartyEmail ? true : false}
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="billingPartyEmail"
                            placeholder={t("email.placeholder") || "Email Id"}
                          />
                          {/* <Checkbox label={t("billingPartyEmail_id.action.title") || "Alerts"} /> */}
                          {touched.billingPartyEmail && errors.billingPartyEmail ? (
                            <div>
                              {t(`billingPartyEmail.error_msg.${errors.billingPartyEmail}`) || errors.billingPartyEmail}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={2}></FormUi.Field>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("billingPartyContactPersonNumber.title") || "Mobile No."}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                          error={touched.billingPartyContactPersonNumber && errors.billingPartyContactPersonNumber ? true : false}
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="billingPartyContactPersonNumber"
                            placeholder={t("billingPartyContactPersonNumber.placeholder") || "Mobile No."}
                          />
                          {touched.billingPartyContactPersonNumber && errors.billingPartyContactPersonNumber ? (
                            <div>
                              {t(`billingPartyContactPersonNumber.error_msg.${errors.billingPartyContactPersonNumber}`) ||
                                errors.billingPartyContactPersonNumber}
                            </div>
                          ) : null}
                          {/* <Checkbox label={t("billingPartyContactPersonNumber.action.title") || "Alerts"} /> */}
                        </FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group inline>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("address.title") || "Address"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                          error={touched.billingPartyAddress && errors.billingPartyAddress ? true : false}
                        >
                          <Fieldmik
                            as={TextArea}
                            className="ui input"
                            name="billingPartyAddress"
                            placeholder={
                              t("address.placeholder") || "Company Address"
                            }
                          />
                          {touched.billingPartyAddress && errors.billingPartyAddress ? (
                            <div>
                              {t(`billingPartyAddress.error_msg.${errors.billingPartyAddress}`) ||
                                errors.billingPartyAddress}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={2}></FormUi.Field>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("pincode.title") || "Billing Party Pincode"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                          error={touched.billingPartyPincodeNo && errors.billingPartyPincodeNo ? true : false}
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="billingPartyPincodeNo"
                            placeholder={t("pincode.placeholder") || "billingPartyPincodeNo"}
                          />
                          {touched.billingPartyPincodeNo && errors.billingPartyPincodeNo ? (
                            <div>
                              {t(`billingPartyPincodeNo.error_msg.${errors.billingPartyPincodeNo}`) || errors.billingPartyPincodeNo}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("customer_type_id.title") || "customer_type_id"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                          error={
                            touched.customer_type_id && errors.customer_type_id
                              ? true
                              : false
                          }
                        >
                          <Dropdown
                            clearable
                            style={{ width: "100%", fontWeight: "normal" }}
                            search
                            selection
                            name={`customer_type_id`}
                            placeholder={
                              t("customer_type_id.placeholder") ||
                              "Customer Type"
                            }
                            defaultValue={
                              values.customer_type_id
                            }
                            onChange={(name, data) =>
                              setFieldValue(`customer_type_id`, data.value)
                            }
                            options={customertype}
                          />
                          {touched.customer_type_id && errors.customer_type_id ? (
                            <div>
                              {t(`customer_type_id.error_msg.${errors.customer_type_id}`) ||
                                errors.customer_type_id}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={2}></FormUi.Field>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("industry.title") || "industry"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                          error={
                            touched.industrySegmentId && errors.industrySegmentId
                              ? true
                              : false
                          }
                        >
                          <Dropdown
                            clearable
                            style={{ width: "100%", fontWeight: "normal" }}
                            search
                            selection
                            name="industrySegmentId"
                            placeholder={
                              t("industry.placeholder") ||
                              "Industry"
                            }
                            defaultValue={
                              values.industrySegmentId
                            }
                            onChange={(name, data) =>
                              setFieldValue(`industrySegmentId`, data.value)
                            }
                            options={industryName}
                          />
                          {touched.industrySegmentId && errors.industrySegmentId ? (
                            <div>
                              {t(`industrySegmentId.error_msg.${errors.industrySegmentId}`) ||
                                errors.industrySegmentId}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("creditPeriod.title") || "Credit Period"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                          error={touched.creditPeriod && errors.creditPeriod ? true : false}
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="creditPeriod"
                            placeholder={t("creditPeriod.placeholder") || "Credit Period"}
                          />
                          {touched.creditPeriod && errors.creditPeriod ? (
                            <div>
                              {t(`creditPeriod.error_msg.${errors.creditPeriod}`) || errors.creditPeriod}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={2}></FormUi.Field>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("billingPartyContactPerson.title") || "Credit Period"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                          error={touched.billingPartyContactPerson && errors.billingPartyContactPerson ? true : false}
                        >
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="billingPartyContactPerson"
                            placeholder={t("billingPartyContactPerson.placeholder") || "Credit Period"}
                          />
                          {touched.billingPartyContactPerson && errors.billingPartyContactPerson ? (
                            <div>
                              {t(`billingPartyContactPerson.error_msg.${errors.billingPartyContactPerson}`) || errors.billingPartyContactPerson}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width={2}>
                          <label className="labelName">
                            {t("panNumber.title") || "Pan Number"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={4}>
                          <Fieldmik
                            component={MyNormalInput}
                            size='mini'
                            name='panNumber'
                            value={values.panNumber}
                            type='text'
                            placeholder='Please Enter Pan No.'
                          />
                          {touched.panNumber && errors.panNumber ? (
                            <div className="error-msg">
                              {errors.panNumber}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                    </div>
                  </div>
                </div>
              </Formiker>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {isSubmitting ? "Loading..." : ""}
          <Button
            type="submit"
            onClick={handleSubmited}
            // disabled={isSubmitting || (values.allVendors && values.broadcast_start_datetime, values.broadcast_end_datetime)  ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("action_button.submit") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
// TODO: validation
const FormikBroadcast = withFormik({
  validationSchema: yup.object({
    //billingPartyCode: yup.string().required("required"),
    // billingPartyCode: yup.string().when(`customerNumber != 1379`, {
    //   is: (value) => { if (customerNumber != 1379) return true; else return false; },
    //   then: yup.string().required('required'),
    //   otherwise: yup.string()
    // }),
    billingPartyName: yup.string().required(FIELD_IS_REQUIRED),
    panNumber: yup.string().optional().matches(AllRegex.PANIN, INVALID_PAN_NUMBER)
    // address: yup
    //   .string()
    //   .required("required"),
    // billingPartyContactPersonNumber: yup.string().matches(AllRegex.MobileNumber, "billingPartyContactPersonNumber"),
    // billingPartyAddress: yup
    //   .string()
    //   .required("required"),
    // billingPartyContactPerson: yup.string().optional().matches(AllRegex.Name, "billingPartyContactPerson"),
    // state: yup.string().optional().matches(AllRegex.Name, "state"),
    // billingPartyPincodeNo: yup
    //   .string()
    //   .required("required"),
    // customer_type_id: yup
    //   .string()
    //   .optional()
    //   .matches(AllRegex.customer_type_id, "customer_type_id"),
    // industrySegmentId: yup
    //   .string()
    //   .optional()
    //   .matches(AllRegex.industry, "industry"),
  }),
  mapPropsToValues: (props) => ({
    billingPartyCode: "",
    billingPartyName: "",
    billingPartyAddress: "",
    billingPartyContactPersonNumber: "",
    address: "",
    billingPartyContactPerson: "",
    state: "",
    billingPartyPincodeNo: "",
    customer_type_id: "",
    industrySegmentId: "",
    panNumber: "",
  }),
  handleSubmit(values, { setSubmitting, props }) {
    CreateAxios({
      url: "billing_party",
      payload: { ...values },
    })
      .then((res) => {
        setSubmitting(false);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message.message,
        });
        props.reFetchConsignee();
        // setmodalOpen(false);
      })
      .catch((err) => {
        console.log(err);
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err.data ? err.data.message : err.message,
        });
        props.reFetchConsignee();
      });
  },
})(ModalCreateConsignee);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("create_billing_party")(FormikBroadcast)
);
